module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 37
// module chunks = 0